'use client';

import { Dialog, DIALOG_ROLES, DialogContent, DialogFooter } from '@pixum/web-dialog';
import Button, { ButtonVariants } from '@pixum/button';
import Text, { TEXT_VARIANT } from '@pixum/text';

interface DPOAlertDialogProps {
  open: boolean;
  onClose: () => void;
  headline: string;
  info: string;
  okayLabel: string;
}

export function DPOAlertDialog({ open, onClose, headline, info, okayLabel }: DPOAlertDialogProps) {
  return (
    <Dialog
      content={
        <DialogContent>
          <>
            <Text variant={TEXT_VARIANT.HEADLINE}>{headline}</Text>
            <Text variant={TEXT_VARIANT.BODY}>{info}</Text>
          </>
        </DialogContent>
      }
      footer={
        <DialogFooter
          right={
            <Button label={okayLabel} variant={ButtonVariants.TERTIARY} onClick={onClose}>
              {okayLabel}
            </Button>
          }
          role={DIALOG_ROLES.ALERT}
        />
      }
      onClose={onClose}
      open={open}
      role={DIALOG_ROLES.ALERT}
      showCloseButton={false}
    />
  );
}
